import { useState, useEffect } from 'react';
import { Users as UsersIcon, Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingId, setSendingId] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await api.get('/admin/users');
    setUsers(res.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const sendResetLink = async (user) => {
    setSendingId(user.user_id);
    try {
      const res = await api.post(`/admin/users/${user.user_id}/send-reset-link`, { origin_url: window.location.origin });
      toast.success(res.data.message);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not send reset link');
    } finally {
      setSendingId(null);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-forest"></div></div>;
  }

  return (
    <div className="p-6 md:p-10" data-testid="admin-users-page">
      <div className="flex items-center gap-3 mb-6">
        <UsersIcon className="w-6 h-6 text-forest" />
        <h1 className="font-playfair text-2xl font-bold text-dark">Users</h1>
      </div>
      <div className="bg-white rounded-2xl border border-forest/10 overflow-x-auto">
        <table className="w-full">
          <thead className="bg-cream">
            <tr>
              {['Name', 'Email', 'Role', 'Password login?', ''].map((h) => (
                <th key={h} className="px-4 py-3 text-left font-manrope text-sm font-semibold text-dark/60">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-forest/10">
            {users.map((u) => (
              <tr key={u.user_id} data-testid={`admin-user-row-${u.user_id}`}>
                <td className="px-4 py-3 font-manrope font-semibold text-dark">{u.name}</td>
                <td className="px-4 py-3 font-manrope text-dark/70 flex items-center gap-2"><Mail className="w-4 h-4 text-dark/30" />{u.email}</td>
                <td className="px-4 py-3 font-manrope text-sm capitalize text-dark/70">{u.role}</td>
                <td className="px-4 py-3 font-manrope text-sm text-dark/50">{u.has_password ? 'Yes' : 'Google only'}</td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => sendResetLink(u)}
                    disabled={sendingId === u.user_id || !u.has_password}
                    className="btn-secondary py-1.5 px-4 text-xs inline-flex items-center gap-1.5 disabled:opacity-50"
                    data-testid={`send-reset-link-${u.user_id}`}
                  >
                    <Send className="w-3.5 h-3.5" />
                    {sendingId === u.user_id ? 'Sending...' : !u.has_password ? 'Google only' : 'Send Reset Link'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
